import React from "react";
import { useTranslation } from "react-i18next";
import VelavuAlertModal from "../../../elements/velavu-alert-modal/velavu-alert-modal";
import VelavuAlertModalActions from "../../../elements/velavu-alert-modal/velavu-alert-modal-actions";
import VelavuAlertModalTitle from "../../../elements/velavu-alert-modal/velavu-alert-modal-title";
import VelavuAlertModalContent from "../../../elements/velavu-alert-modal/velavu-alert-modal-content";
import VelavuButton from "../../../elements/velavu-button";

export interface RulesEditorSMSDisclaimerModalProps {
	onClose?: () => void;
}

export default function RulesEditorSMSDisclaimerModal(
	props: RulesEditorSMSDisclaimerModalProps,
) {
	const { t } = useTranslation();

	return (
		<VelavuAlertModal>
			<VelavuAlertModalTitle>
				{t("rules.editor.sms_disclaimer.title")}
			</VelavuAlertModalTitle>

			<VelavuAlertModalContent>
				{t("rules.editor.sms_disclaimer.body")}
				<br />
				<br />
				<span className="p2m">
					{t("rules.editor.sms_disclaimer.terms_label")}
				</span>{" "}
				<a
					href="https://velavu.com/terms"
					target="_blank"
					rel="noreferrer"
				>
					velavu.com/terms
				</a>
				<br />
				<span className="p2m">
					{t("rules.editor.sms_disclaimer.privacy_label")}
				</span>{" "}
				<a
					href="https://velavu.com/privacy-policy"
					target="_blank"
					rel="noreferrer"
				>
					velavu.com/privacy-policy
				</a>
			</VelavuAlertModalContent>

			<VelavuAlertModalActions>
				<VelavuButton
					fullWidth
					onClick={props.onClose}
					label={t("common.close")}
				/>
			</VelavuAlertModalActions>
		</VelavuAlertModal>
	);
}
